import React, { PureComponent } from 'react';
import { shape, string, node, bool } from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import {
  staffLabel,
  professorLabel,
  premiumChipBg,
  professionalChipBg,
  plusChipBg,
  mentorChipBg,
} from '../styles/colors';
import { reduceClasses } from '../utils/testUtils';

const styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    '& > span': {
      fontFamily: 'Nunito, Arial, sans-serif, dinpro-bold',
      fontWeight: 'bold',
      fontSize: '11px',
      lineHeight: '16px',
      letterSpacing: '0.8px',
      textTransform: 'uppercase',
    },
  },
  staff: {
    '& > span': {
      color: staffLabel,
    },
  },
  professor: {
    '& > span': {
      color: professorLabel,
    },
  },
  premium: {
    '& > span': {
      color: premiumChipBg,
    },
  },
  plus: {
    '& > span': {
      color: plusChipBg,
    },
  },
  professional: {
    '& > span': {
      color: professionalChipBg,
    },
  },
  mentor: {
    '& > span': {
      color: mentorChipBg,
    },
  },
  link: {
    display: 'inline-block',
    textDecoration: 'none',
  },
  title: {
    fontSize: '12px',
    lineHeight: '16px',
  },
};

/**
 * Generally used as user tag.
 */
class Chip extends PureComponent {
  getTitle = () => {
    const {
      label,
      premium,
      professional,
      plus,
      prof,
      staff,
      mentor,
    } = this.props;

    if (label && label.length > 0) return label;
    if (premium) return 'Premium';
    if (professional) return 'Pro';
    if (plus) return 'Plus';
    if (prof) return 'Profesor';
    if (staff) return 'Staff';
    if (mentor) return 'Mentor';
    return '';
  };

  render() {
    const {
      classes: classesProp,
      className,
      href,
      prof,
      staff,
      premium,
      professional,
      plus,
      mentor,
      test,
    } = this.props;
    const classes = test ? reduceClasses(classesProp) : classesProp;

    if (href) {
      return (
        <a
          className={classNames(classes.link, className)}
          href={href}
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          <div
            className={classNames(classes.root, {
              [classes.premium]: premium,
              [classes.professional]: professional,
              [classes.plus]: plus,
              [classes.professor]: prof,
              [classes.staff]: staff,
              [classes.mentor]: mentor,
            })}
          >
            <span>{this.getTitle()}</span>
          </div>
        </a>
      );
    }
    return (
      <div
        className={classNames(
          classes.root,
          {
            [classes.premium]: premium,
            [classes.professional]: professional,
            [classes.plus]: plus,
            [classes.professor]: prof,
            [classes.staff]: staff,
            [classes.mentor]: mentor,
          },
          className,
        )}
      >
        <span>{this.getTitle()}</span>
      </div>
    );
  }
}

Chip.propTypes = {
  /** Classes from the styleSheet generated. */
  classes: shape({}).isRequired,
  /** Useful to extend the styleSheet applied to the root component. */
  className: string,
  /** Custom label for the chip. Only used if neither premium, prof or staff props are true. */
  label: node,
  /** Optional href. */
  href: string,
  /** For premium tag styles. */
  premium: bool,
  /** For professional tag styles. */
  professional: bool,
  /** For plus tag styles. */
  plus: bool,
  /** For professor tag styles. */
  prof: bool,
  /** For staff tag styles. */
  staff: bool,
  /** For mentor tag styles. */
  mentor: bool,
  /** Useful for snapshot testing. */
  test: bool,
};

Chip.defaultProps = {
  className: undefined,
  label: undefined,
  href: undefined,
  premium: false,
  professional: false,
  plus: false,
  prof: false,
  staff: false,
  mentor: false,
  test: false,
};

export default withStyles(styles)(Chip);
